import React, { useState } from "react"
import "semantic-ui-css/semantic.min.css"

import { Checkbox } from "semantic-ui-react"

const DateFilter = ({
  onDateFilterChange = () => {},
} = {}) => {
  const [isFilterOpen, setIsFilterOpen] = useState(false)
  const [selectedFilters, setSelectedFilters] = useState([])
  const [selectedStartDate, setSelectedStartDate] = useState("")
  const [selectedEndDate, setSelectedEndDate] = useState("")

  const toggleFilter = () => {
    setIsFilterOpen(!isFilterOpen)
  }

  const handleFilterSelect = (filter) => {
    // setSelectedFilters((prevFilters) => {
    //   if (prevFilters.includes(filter)) {
    //     return prevFilters.filter((f) => f !== filter)
    //   }
    //   return [...prevFilters, filter]
    // })
    setSelectedFilters([filter])
    setSelectedStartDate("")
    setSelectedEndDate("")
    onDateFilterChange(filter)
  }

  const handleClearFilter = () => {
    setSelectedFilters([])
    setSelectedStartDate("")
    setSelectedEndDate("")
    setIsFilterOpen(false)
    onDateFilterChange(null)
  }

  const handleStartDateChange = ({ target: { value: dateValue = "" } = {} } = {}) => {
    setSelectedStartDate(dateValue)
    if (dateValue && selectedEndDate) {
      onDateFilterChange({
        start: new Date(dateValue),
        end: new Date(selectedEndDate),
      })
    }
  }

  const handleEndDateChange = (e) => {
    const dateValue = e.target.value
    setSelectedEndDate(dateValue)
    if (dateValue && selectedStartDate) {
      onDateFilterChange({
        start: new Date(selectedStartDate),
        end: new Date(dateValue),
      })
    }
  }

  return (
    <div>
      {/* Bouton Dates */}
      <button
        type="button"
        className="facetselector ui button"
        onClick={toggleFilter}
      >
        <i className="calendar outline icon" />
        Dates
      </button>

      {/* Filtre déroulant */}
      {isFilterOpen && (
        <div className="filter-popup">
          <h4>Beginning - End</h4>
          <input
            type="date"
            placeholder="dd/mm/yyyy"
            className="date-input"
            value={selectedStartDate}
            onChange={handleStartDateChange}
          />
          <input
            type="date"
            placeholder="dd/mm/yyyy"
            className="date-input"
            value={selectedEndDate}
            onChange={handleEndDateChange}
          />
          <h4>Quick Filter</h4>
          <div className="filter-options">
            {["7 last days", "Current Month", "Last Month", "Current Year", "Last Year"].map((filter) => (
              <div
                key={filter}
                className="selection"
                onClick={() => handleFilterSelect(filter)}
                onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") handleFilterSelect(filter) }}
                role="button"
                tabIndex="0"
              >
                <label className="label-filter-button" htmlFor={filter}>
                  <Checkbox type="checkbox" id={filter} name={filter} checked={selectedFilters.includes(filter)} readOnly />
                  {filter}
                </label>
              </div>
            ))}
          </div>
          <button
            type="button"
            className="ui button"
            onClick={() => { handleClearFilter() }}
            style={{ marginTop: "10px" }}
          >
            Clear
          </button>
          <button
            type="button"
            className="ui button"
            onClick={() => { setIsFilterOpen(false) }}
            style={{ marginTop: "10px" }}
          >
            Close
          </button>
        </div>
      )}

      {/* Afficher la sélection */}
      {selectedFilters.length > 0 && (
        <div className="active-parents">
          <div className="selected-active-filter date-active-filter">
            <span>
              {selectedFilters.join(", ")}
            </span>
            <button
              type="button"
              className="remove-filter date-active-filter-button"
              onClick={() => handleClearFilter()}
            >
              &times;
            </button>
          </div>
        </div>
      )}

      {(selectedStartDate || selectedEndDate) && (
        <div className="selected-active-filter date-active-filter">
          <span>
            {selectedStartDate}
            -
            {selectedEndDate}
          </span>
          <button
            type="button"
            className="remove-filter date-active-filter-button"
            onClick={() => handleClearFilter()}
          >
            &times;
          </button>
        </div>
      )}
    </div>
  )
}

export default DateFilter
